import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import Approved from '../components/mainpage/subcomponent/approved'
const MainApproved = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <Approved />
            </div>
        </div>
    )
}

export default MainApproved